module.exports = __webpack_public_path__ + "img/查看.19d974e9.svg";